import Text from 'common/values/text/text';

export default class ProjectDescription extends Text {
  public static get Prototype(): ProjectDescription {
    return new ProjectDescription('Prototype');
  }

  public get isEmpty(): boolean {
    return this.value === '';
  }

  public static fromJSON(value: string): ProjectDescription {
    return new ProjectDescription(value);
  }

  public override fromJSON(value: string): ProjectDescription {
    return ProjectDescription.fromJSON(value);
  }

  public toJSON(): string {
    return this.value;
  }
}
